import { useEffect, useState } from 'react';
import { useIsMutating } from '@tanstack/react-query';
import { transactionQueryKey, transactionsQueryKey, useTransaction } from 'src/hooks/queries/transactions';
import usePaginatedTransactions from 'src/hooks/usePaginatedTransactions';

export const useUpdatingTransaction = (
    id: number,
    inList: boolean = false,
    selectedTransaction: boolean = false
): { isUpdatingTransaction: boolean } => {
    const isUpdatingSingleTransaction: boolean = useIsMutating({ mutationKey: [transactionQueryKey, id] }) > 0;
    const isBulkUpdatingTransaction: boolean =
        useIsMutating({ mutationKey: [transactionsQueryKey, 'group'] }) > 0 && selectedTransaction;
    const { isFetching } = inList ? usePaginatedTransactions() : useTransaction(id);
    const _isUpdatingTransaction = isUpdatingSingleTransaction || isBulkUpdatingTransaction;
    const [isUpdatingTransaction, setIsUpdatingTransaction] = useState(false);

    useEffect(() => {
        if (isUpdatingTransaction && !_isUpdatingTransaction) {
            setIsUpdatingTransaction(isFetching);
        } else {
            setIsUpdatingTransaction(_isUpdatingTransaction);
        }
    }, [_isUpdatingTransaction, isFetching]);

    return { isUpdatingTransaction };
};
